import { render, staticRenderFns } from "./ownerDetailVisit.vue?vue&type=template&id=46996b38"
import script from "./ownerDetailVisit.vue?vue&type=script&lang=js"
export * from "./ownerDetailVisit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports